<template>
  <div id="main">

    <el-container style="height: 100%;">
      <el-header  id="top" style="background-color: #409EFF">
        <el-row style="line-height: 60px; color:#FFF">
          <div style="float: left; margin-right: 10px"><span class="el-icon-menu" style="font-size:20pt;"></span> <span style="font-size: 20pt">小度订单助手</span></div>
          <div  style="float: right; margin-right: 20px">
            <a href="http://www.taobao.com/webww/ww.php?ver=3&touid=wgaofa&siteid=cntaobao&status=1&charset=utf-8"
               target="_blank"><img style="vertical-align: middle" alt="点这里给我发消息" border="0" src="http://amos.alicdn.com/online.aw?v=2&uid=wgaofa&site=cntaobao&s=1&charset=utf-8"></a>
          </div>
          <div  style="float: right; margin-right: 20px; font-size:10pt">
            <span>剩余【{{days}}天】</span>
            <el-link style="color:#FFF; text-decoration:none;" target="_blank" href="https://pc.1688.com/product/detail.htm?productCode=fQscGcd%2F9HaFizJvx37mYjcWBVFj8q2e1ZAcNegUod0%3D&productType=GROUP">续费</el-link>
          </div>
          <div  style="float: right; margin-right: 20px;font-size:10pt">
            <div v-if="logined" ><span  class="el-icon-user-solid"></span><span v-if="">【{{username}}】</span>
              <el-link style="color:#FFF;text-decoration:none;"  @click="logout">退出</el-link>
            </div>
            <div v-else="logined" class="login">
              <el-link style="color:#FFF;font-size: 12pt; text-decoration:none;" @click="login">Login</el-link>
            </div>
          </div>

          <div  style="float: right; margin-right: 40px; font-size:10pt">
            <el-link style="color:#FFF; text-decoration:none;" target="_blank" href="https://auth.1688.com/oauth/authorize?client_id=5417508&site=c2m&redirect_uri=http://c2m.zdinfo.top&state=zhaodu">切换到淘工厂</el-link>
          </div>


          <!--<el-col :span="13"><span class="el-icon-menu"></span> <span style="font-size: 16px">小度订单导出</span></el-col>
          <el-col :span="3" style="text-align: center">剩余 {{days}} 天</el-col>
          <el-col :span="1"><el-link style="color:#FFF;font-size: 12pt; text-decoration:none;" target="_blank" href="https://pc.1688.com/product/detail.htm?productCode=fQscGcd%2F9HaFizJvx37mYjcWBVFj8q2e1ZAcNegUod0%3D&productType=GROUP">订购</el-link></el-col>
          <el-col :span="6" style="text-align: center">
            <div v-if="logined" ><span class="el-icon-user-solid"></span>【{{username}}】
              <el-link style="color:#FFF;font-size: 12pt;text-decoration:none;"  @click="logout">安全退出</el-link>
            </div>
            <div v-else="logined" class="login">
              <el-link style="color:#FFF;font-size: 12pt; text-decoration:none;" @click="login">Login</el-link>
            </div>
          </el-col>
          <el-col :span="1">
            <div>
              <a href="http://www.taobao.com/webww/ww.php?ver=3&touid=wgaofa&siteid=cntaobao&status=1&charset=utf-8"
                 target="_blank"><img alt="点这里给我发消息" border="0" src="http://amos.alicdn.com/online.aw?v=2&uid=wgaofa&site=cntaobao&s=1&charset=utf-8"></a>
            </div>
          </el-col>-->
        </el-row>
      </el-header>
      <el-container >
        <el-aside width="200px"  id="left" style="height: 100%;">
          <el-menu
            @select="handleSelect"
            @open="handleOpen"
            :default-openeds='["G1","G2","G3","G4","G5"]'
            :default-active="active"
            class="el-menu-vertical-demo1"
            style="font-size: 20px;height: 100%;"
          >
            <el-menu-item index="1">
              <i class="el-icon-s-home"></i>
              <span slot="title">首 页</span>
            </el-menu-item>
            <el-submenu index="G1">
              <template slot="title">
                <i class="el-icon-reading"></i>
                <span>打单发货</span>
              </template>
              <el-menu-item index="80">
                <i class="el-icon-tickets"></i>
                <span slot="title">快递模板</span>
              </el-menu-item>
              <el-menu-item index="81">
                <i class="el-icon-printer"></i>
                <span slot="title">打单发货</span>
              </el-menu-item>
              <el-menu-item index="82">
                <i class="el-icon-printer"></i>
                <span slot="title">手工订单</span>
              </el-menu-item>
            </el-submenu>

            <el-menu-item index="2">
              <i class="el-icon-tickets"></i>
              <span slot="title">同步订单</span>
            </el-menu-item>
            <el-menu-item index="3">
              <i class="el-icon-view"></i>
              <span slot="title">查看订单</span>
            </el-menu-item>
            <el-menu-item index="4">
              <i class="el-icon-truck"></i>
              <span slot="title">批量发货</span>
            </el-menu-item>
            <el-menu-item index="5">
              <i class="el-icon-chat-line-round"></i>
              <span slot="title">批量备注</span>
            </el-menu-item>

            <el-menu-item index="8">
              <i class="el-icon-shopping-cart-full"></i>
              <span slot="title">商品管理</span>
            </el-menu-item>
            <el-menu-item index="9">
              <i class="el-icon-finished"></i>
              <span slot="title">定制功能</span>
            </el-menu-item>

            <el-menu-item index="11">
              <i class="el-icon-help"></i>
              <span slot="title">使用帮助</span>
            </el-menu-item>
            <!--<el-menu-item index="12">
              <i class="el-icon-tickets"></i>
              <span slot="title">Print</span>
            </el-menu-item>-->

          </el-menu>
        </el-aside>
        <el-main>
          <router-view ></router-view>
        </el-main>
      </el-container>

    </el-container>


  </div>
</template>

<script>
  import $api from "../api/axios"
  import storage from "../api/storage"

    export default {
      name: "Main",
      data(){
        return {
          active: '1',
          username: '未登录',
          logined: true,
          days: 100,
          version: '基础版',
        }
      },
      methods:{
        handleSelect:function (index) {
          storage.set("active",index);
          switch (index) {
            case "1":
              this.$router.replace({name: 'Index'});
              break;
            case "2":
              this.$router.replace({name: 'ShowSet'});
              break;
            case "3":
              this.$router.replace({name: 'ShowData'});
              break;
            case "4":
              this.$router.replace({name: 'Logistics'});
              break;
            case "5":
              this.$router.replace({name: 'SellerMemo'});
              break;
            case "6":
              this.$router.replace({name: 'Delay'});
              break;
            case "7":
              this.$router.replace({name: 'BeiHuo'});
              break;
            case "8":
              this.$router.replace({name: 'Item'});
              break;
            case "9":
              this.$router.replace({name: 'Custom'});
              break;
            case "10":
              this.$router.replace({name: 'Permission'});
              break;
            case "11":
              this.$router.replace({name: 'Help'});
              break;
            case "12":
              this.$router.replace({name: 'Print'});
              break;
            case "80":
              this.$router.replace({name: 'KddTemp'});
              break;
            case "81":
              this.$router.replace({name: 'Print'});
              break;
            case "82":
              this.$router.replace({name: 'Free'});
              break;

          }
        },
        handleOpen(key, keyPath) {
          console.log(key, keyPath);
        },
        handleClose(key, keyPath) {
          console.log(key, keyPath);
        },
        login(){
          this.logined = true;
        },
        logout(){
          storage.remove("nick");
          storage.remove("subnick");
          storage.remove("token");
          storage.remove("days");
          this.$router.replace({name: 'Login'})
          this.logined = false;
        },
      },
      mounted(){
        let nick = storage.get("nick");
        if(nick == null){
          this.$message.error("您当前没有登录，请登录后进行操作！");
        }else {
          this.active = storage.get("active");
          this.username = storage.get("nick");
          this.days = storage.get("days");
        }
      }
    }
</script>

<style >
  html,body,#app{
    height: 100%;

  }

  #main {
    font-family: ‘宋体’,'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: left;
    color: #2c3e50;
    height: 100%;
  }

  .el-menu-item span{
    font-size: 16px;
  }

  .el-table .cell {
    white-space:normal;
    word-break:break-word;
    color: #000000;
    padding: 0px 0px 0px 2px;
    font-family: Arial;

  }

  .el-table .same-tid {
    /*background: oldlace;*/
    background: #FFFF66;
  }

  .el-table .normal {
    /* background: #FFFF22;*/
  }

  .el-table{
    border-bottom: solid 1px #8cc5ff;
  }
  .el-table td{
    border: solid 1px #8cc5ff;

    padding: 0px 0px;
  }

  td {
    border: solid 0px #8cc5ff;

  }



  .el-link.el-link--default {
    color: #FFF;
  }

  .link {
    color: #ffffff;
    font-size: 12pt;
    font-weight: bold;
    text-decoration:none;
  }
  .login  a:link{
    color: #ffffff;
    font-size: 12pt;
    font-weight: bold;
    text-decoration:none;
  }
  .login  a:visited{
    color: #ffffff;
    font-size: 12pt;
    text-decoration:none;
  }

  .login a:hover {
    color: #ffffff;
    font-size: 13pt;
    text-decoration:none;
  }

  .login a:active {
    color: #ffffff;
    font-size: 13pt;
    text-decoration:none;
  }

</style>



// WEBPACK FOOTER //
// src/page/Main.vue